import React from 'react';
import { ReactComponent as MinusIcon } from '../../../../components/Common/BootstrapIcons/dash.svg';
import { ReactComponent as PlusIcon } from '../../../../components/Common/BootstrapIcons/plus.svg';
import httpClient from '../../../../infrastructure/helpers/common/httpClient';
import  { SelectedOptionValue } from 'react-select-search';
import './ValidationSection.scss';
import ReportCollections from '../../../../infrastructure/types/Functions/ReportCollections';
import ReportConfig from '../../../../types/report/ReportConfig';
import AccuracyValidation from '../../../../types/report/AccuracyValidation';
import ValidationFilter from '../../../../types/report/ValidationFilter';

interface Props {
    heading: string;
    htmlId: string;
    onClick: (htmlId: string) => void;
    isExpanded: (htmlId: string) => boolean;
    regime: string;
    validationKind: string;
    reportConfig: ReportConfig,
    sectionId: string;
    isReadOnly: boolean;
}

interface State {
    showFileUploadPopup: boolean,
    showSearchPopup: boolean,
    searchBy: string,
    searchForValue: string,
    showSearchSpinner: boolean
}

const defaultSearchByOption = 'Search By ';
class ValidationSection extends React.Component<Props, State>{

    constructor(props: Props) {
        super(props);

        this.state = {
            showFileUploadPopup: false,
            showSearchPopup: false,
            searchBy: defaultSearchByOption,
            searchForValue: '',
            showSearchSpinner: false
        }

        this.onClick = this.onClick.bind(this);
    }

    onClick(): void {
        this.props.onClick(this.props.htmlId);
    }

    getClassName(): string {
        let classes = ['collapse'];

        if (this.props.isExpanded(this.props.htmlId)) {
            classes.push('show');
        }

        return classes.join(' ');
    }

    resolveIcon(): JSX.Element {

        return this.props.isExpanded(this.props.htmlId) ? <MinusIcon /> : <PlusIcon />;
    }

    resolveTooltip(): string {

        return this.props.isExpanded(this.props.htmlId) ? 'collapse' : 'expand';
    }

    getItem(actionItem: string) {
        return { id: actionItem, name: actionItem, item: actionItem, preventDelete: false };
    }

    render(): JSX.Element {
        return (
            <>
                <div className="section-heading" style={{ paddingLeft: '25px' }}>
                    <div className='display-flex  flex-align-center'>
                        <div className='width-250px display-flex'>
                            <h5 id={this.props.htmlId}>
                                {this.props.heading}
                            </h5>
                            <button id={`btn-expand-${this.props.htmlId}`} className="transparent-button" onClick={this.onClick} title={this.resolveTooltip()}>
                                {this.resolveIcon()}
                            </button>
                        </div>
                    </div>
                </div >

                <div className={this.getClassName()} style={{ paddingLeft: '25px' }}>
                    {this.props.children}
                </div>
            </>
        );
    }
}

export default ValidationSection;
